import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CheckoutData from './../../_common/_props/PrimerCheckoutDataPropsIos.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`primerDidCompleteCheckoutWithData(_:additionalInfo:)
`}</code></pre>
    <p>{`This method will be called with the when the payment has been completed, returning the payment's data.`}<br /><br />{`
⚠️ This method won't be called when you are using manual payment handling, or the vault manager.`}</p>
    <h3>{`Parameters`}</h3>
    <Group mdxType="Group">
	<CheckoutData mdxType="CheckoutData" />
    </Group>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`// 👇 Add this
import PrimerSDK

// 👇 Conform to PrimerDelegate
class MyViewController: UIViewController, PrimerDelegate {

    // ...

    // 👇 Add this
    func primerDidCompleteCheckoutWithData(_ data: PrimerCheckoutData) {
        // Do something with the payment's data
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      